// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-3dd96ced] .v-toolbar__content{padding-left:0px;padding-right:0px}", ""]);
// Exports
module.exports = exports;
